import React from "react";
import { useAuth } from "../context/AuthContext";

export default function LandingPage() {
  const { user, checkingAuth } = useAuth();

  const handleLogin = () => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_GOOGLE_REDIRECT_URI;

    if (!clientId || !redirectUri) {
      alert("Missing required OAuth environment variables.");
      return;
    }

    const scopes = [
      "https://www.googleapis.com/auth/photospicker.mediaitems.readonly", // NEW Picker API scope
      "openid", // Standard for OpenID Connect (basic login)
      "profile", // For user's basic profile information
      "email", // For user's email address
    ].join(" "); // Join them into a single string with spaces between each scope

    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${encodeURIComponent(scopes)}&access_type=offline&prompt=consent`;

    window.location.href = authUrl;
  };

  if (checkingAuth) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center text-xl">
        Checking authentication...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6">
      <img
        src="/DropGroove-Logo.png"
        alt="Drop Groove Logo"
        className="w-64 md:w-80 mb-10 drop-shadow-lg"
      />

      <h1 className="text-4xl md:text-5xl font-bold text-center mb-4">
        Experience The Rhythm Of Selling Vinyl
      </h1>

      <p className="text-lg md:text-xl text-center max-w-xl mb-6 text-gray-300">
        Drop Groove helps vinyl sellers automate eBay listings quickly!
      </p>

      {user ? (
        <p className="text-lg mb-6">
          Logged in as <strong>{user.email}</strong>
        </p>
      ) : (
        <button
          onClick={handleLogin}
          className="bg-red-600 hover:bg-red-700 text-white text-lg px-6 py-3 rounded-2xl shadow-lg transition-all"
        >
          Log In with Google
        </button>
      )}

      <img
        src="/crate.png"
        alt="Vinyl Crate"
        className="w-48 md:w-64 mt-10 opacity-90"
      />

      <footer className="absolute bottom-4 text-sm text-gray-500">
        © {new Date().getFullYear()} Drop Groove
      </footer>
    </div>
  );
}
